import Email from "../../shared/email";
import Phone from "../../shared/phone";
import PropTypes from "prop-types";
import React from "react";
import ReadMore from "../../shared/read-more/";
import Social from "../../shared/social/social";

const Member = ({ member, memberDisplayLogic }) => {
  const colClass = memberDisplayLogic.hasPhotos
    ? "col-xs-8 col-xxs-16"
    : "col-xs-16";
  let photo;
  if (memberDisplayLogic.showLargePhotos) {
    photo = member.largePhoto.url;
  } else {
    photo = member.smallPhoto ? member.smallPhoto.url : null;
  }
  return (
    <div className="row member">
      <div className={"photo " + colClass}>
        <img src={photo} alt={member.displayName} className="profile-photo" />
      </div>
      <div className={colClass}>
        <div className="member-info">
          <h3 className="member-name">{member.displayName}</h3>
          <div className="italicize">{member.title}</div>
          <div className="italicize">{member.license}</div>
          <div>
            <Phone number={member.primaryPhone} />
          </div>
          <div>
            <Email email={member.emailAddress} showPrefix={false} />
          </div>
          <div>
            <a href={member.websiteUrl} target="_blank">
              {member.websiteUrl}
            </a>
          </div>
          <div>
            <Social socials={member.socials} />
          </div>
        </div>
        <div className="member-bio">
          <ReadMore id={"member" + member.agentId} height={300}>
            <p dangerouslySetInnerHTML={{ __html: member.biography }}></p>
          </ReadMore>
        </div>
      </div>
    </div>
  );
};

Member.propTypes = {
  member: PropTypes.object.isRequired,
  memberDisplayLogic: PropTypes.object.isRequired,
};

export default Member;



// WEBPACK FOOTER //
// ./src/components/about/team/member.js